import { render } from "./IconChainTimingKit.vue?vue&type=template&id=052559a8&lang=pug&bindings={\"id\":\"props\"}"
import script from "./IconChainTimingKit.vue?vue&type=script&lang=js"
export * from "./IconChainTimingKit.vue?vue&type=script&lang=js"
script.render = render

export default script